// extracted by mini-css-extract-plugin
export default {"description":"ReleasesControlPanel_description__5qy+Q"};